import React from 'react';
function CornerDownLeft({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M3.33325 11.3166H13.3333C14.0277 11.2944 15.4166 9.99999 15.4166 8.33332C15.4166 6.24999 14.1666 5.41666 13.3333 5.41666C12.0833 5.41666 10.9721 5.41666 9.99992 5.41666M3.33325 11.3166L6.66659 7.98329M3.33325 11.3166L6.66659 14.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CornerDownLeft;
